import React, { Fragment, useContext } from 'react';

import { ComponentContext } from '../../../context/componentContext';

import FarmGalleryCard from './FarmGalleryCard';

const FarmGallery = ({ data }) => {
  const { menuOpen } = useContext(ComponentContext);
  return (
    <Fragment>
      <div className={`flex flex-wrap justify-center ${menuOpen ? 'pl-8 md:pl-24' : ''}`}>
        <div className="w-full md:w-4/5 lg:w-133">
          <div className="bg-cf-300 text-white rounded px-6 py-10 text-center">
            <h4 className="font-semibold">Welcome to your Farm Gallery!</h4>
            <p className="text-sm md:text-base">
              Here, you can view all the latest pictures and videos of your farms
            </p>
          </div>
        </div>
      </div>
      {data && data.feeds.length > 0 ? (
        <div className="px-4 md:px-0 mt-10">
          {data.feeds.map(activity => (
            <div key={activity._id}>
              {activity.tasks.map(task => (
                <div
                  key={task._id}
                  className={`flex flex-wrap justify-center pb-10 ${menuOpen ? 'md:pl-24' : ''}`}
                >
                  <FarmGalleryCard crop={data.crop} activityTitle={activity.title} task={task} />
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div
          className={`flex flex-wrap justify-center mt-10 px-4 md:px-0 ${
            menuOpen ? 'md:pl-24' : ''
          }`}
        >
          <div className="text-center w-full md:w-4/5 lg:w-3/5 bg-white mb-20 px-6 py-4">
            <h5 className="text-base font-bold">No feed currently avaliable.</h5>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FarmGallery;
